var exports = {
  "k": "x43aef4ae--440141--container",
};

module.exports = exports;
